import { ActionGroupTypes, ActionStatusTypes } from "../../../enum/ActionStatusTypes";
import * as logger from "../../../logger";
import { getNodeById } from "../../../nodeSelector";
import * as nodeUtils from "../../../utils/nodeUtils";
import * as pathUtils from "../../../utils/pathUtils";
import * as systemUtils from "../../../utils/systemUtils";
import { ACTION_PREFIX_PARAMETER } from "./abstract/parameterAbstract";

const _action = `${ACTION_PREFIX_PARAMETER}_update_output`;
const _header = `Update output value`;

export const updateParameterValueDefault = (root, id, valueDefault) => {
  const _payload = updateParameterValueDefaultLogic(root, id, valueDefault);

  logger.logAction(_action, _payload, ACTION_PREFIX_PARAMETER);

  return { root, info: _payload };
};

//--------------------------------------------------------------------------------

export const updateParameterValueDefaultLogic = (root, id, valueDefault) => {
  const { data: _node, index: _index } = getNodeById(root, id);

  if (!_node) {
    throw new Error("Parameter to update not found");
  }

  if (nodeUtils.getValueDefault(_node) === valueDefault) {
    return generatePayloadIndifferent();
  }

  const { data: _nodeParent } = getNodeById(root, pathUtils.getIdParent(id));

  const _nodeBackup = systemUtils.createDeepCopy(_node);
  const _valueDefaultBackup = nodeUtils.getValueDefault(_node);

  nodeUtils.setValueDefault(_node, valueDefault);

  return generatePayload(_nodeBackup, _index, _nodeParent, _valueDefaultBackup);
};

//--------------------------------------------------------------------------------

const generatePayloadIndifferent = () => {
  const _payload = {
    status: ActionStatusTypes.INDIFFERENT,
    action: _action,
    time: systemUtils.getTimestamp(),
  };

  return _payload;
};

const generatePayload = (node, index, nodeParent, outputBefore) => {
  return {
    group: ActionGroupTypes.UPDATE,
    status: ActionStatusTypes.SUCCESS,
    action: _action,
    time: systemUtils.getTimestamp(),
    header: _header,
    description: generatePayloadDescription(node),
    node: node,
    uuid: nodeUtils.getUUID(node),
    uuidParent: nodeUtils.getUUID(nodeParent),
    index: index,
    outputBefore: outputBefore,
    outputAfter: nodeUtils.getValueDefault(node),
  };
};

const generatePayloadDescription = (node) => {
  return `Update the output value of '${nodeUtils.getName(node)}'.`;
};
